
import HomePage from '../pages/home.f7.html';
import NotFoundPage from '../pages/404.f7.html';
import Booking from '../pages/booking.f7.html';
import BookingConfirm from '../pages/booking_confirm.f7.html';
import Bookings from '../pages/bookings.f7.html';
import Detail from '../pages/detail.f7.html';
import Chatlist from '../pages/chatlist.f7.html';
import Chat from '../pages/chat.f7.html';
import Explore from '../pages/explore.f7.html';
import Profile from '../pages/profile.f7.html';
import Menu from '../pages/menu.f7.html';
import Menu1 from '../pages/menu1.f7.html';
import MenuEvents from '../pages/menu_events.f7.html';
import MyOrders from '../pages/myorders.f7.html';
import MyOrder from '../pages/myorder.f7.html';
import LegalInfo from '../pages/legalinfo.f7.html';
import Hotel from '../pages/hotel.f7.html';
import FoodDelivery from '../pages/food-delivery.f7.html';
import Disco from '../pages/poi-website.f7.html';
import DiscoEvent from '../pages/poi-event.f7.html';
import DiscoOtherExperience from '../pages/poi-other-experience.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/booking/:id/:promo/',
    component: Booking,
  },
  {
    path: '/booking/:id/',
    component: Booking,
  },
  {
    path: '/booking_confirm/',
    component: BookingConfirm,
  },
  {
    path: '/bookings/',
    component: Bookings,
  },
  {
    path: '/hotel/',
    component: Hotel,
  },
  {
    path: '/food-delivery/',
    component: FoodDelivery,
  },
  {
    path: '/explore/',
    component: Explore,
  },
  {
    path: '/explore/:type/',
    component: Explore,
  },
  {
    path: '/detail/:id/',
    component: Detail,
  },
  {
    path: '/disco/:id/',
    component: Disco,
  },
  {
    path: '/poi-event/:poi/:ev/',
    component: DiscoEvent,
  },
  {
    path: '/poi-other-experience/:poi/:id/',
    component: DiscoOtherExperience,
  },
  {
    path: '/chatlist/',
    component: Chatlist,
  },
  {
    path: '/chat/:id/',
    component: Chat,
  },
  {
    path: '/profile/',
    component: Profile,
  },
  {
    path: '/legalinfo/',
    component: LegalInfo,
  },
  {
    path: '/menu/:idpoi/',
    component: Menu,
  },
  {
    path: '/menu_events/:idpoi/:idevent/',
    component: MenuEvents,
  },
  {
    path: '/menu1/:idpoi/',
    component: Menu1,
  },
  {
    path: '/myorders/',
    component: MyOrders,
  },
  {
    path: '/myorder/:id/',
    component: MyOrder,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;